import moment from "moment-timezone";
import { DAYS_OF_WEEK } from "constants/daysOfWeek";
import type { TScheduleIntervalTimeSlot } from "../types";

function pushIntervalTimeslot(
  array: TScheduleIntervalTimeSlot[],
  item: TScheduleIntervalTimeSlot,
) {
  let res = array;

  if (!array) {
    res = [];
  }
  if (
    res.some(
      (el) =>
        el?.startHour === item?.startHour &&
        el?.duration[0] === item?.duration[0] &&
        el?.duration[1] === item?.duration[1],
    )
  ) {
    return res;
  }

  return res.push(item);
}

/**
 * create time slot placeholder for each hour
 */
function create24HourSlots<T = any>(): T[][] {
  return Array.from({ length: 24 }, () => []);
}

export const getScheduleIntervalsByDay = (
  scheduleIntervals: ScheduleInterval[],
  timezone: TimeZone,
): Record<string, TScheduleIntervalTimeSlot[][]> => {
  const result = scheduleIntervals.reduce(
    (prev, curr) => {
      const start = moment(curr.start_time).tz(timezone);
      const day = DAYS_OF_WEEK[start.weekday()];
      const startHour = start.hour();
      const startMin = start.minute();

      const end = moment(curr.end_time).tz(timezone);
      const endHour = end.hour() || 24;
      const endMin = end.minute();

      // only return one item
      if (startHour === endHour) {
        pushIntervalTimeslot(prev[day][startHour], {
          startHour,
          duration: [startMin, endMin],
        });
        return prev;
      }

      const firstItem = {
        startHour,
        duration: [startMin, 60],
      };
      pushIntervalTimeslot(prev[day][startHour], firstItem);

      Array(endHour - startHour - 1)
        .fill(0)
        .forEach((_, i) => {
          const currStartHour = startHour + 1 + i;

          pushIntervalTimeslot(prev[day][currStartHour], {
            startHour: currStartHour,
            duration: [0, 60],
          });
        });

      if (endMin !== 0) {
        // remaining last hour
        pushIntervalTimeslot(prev[day][endHour], {
          startHour: endHour,
          duration: [0, endMin],
        });
      }

      return prev;
    },
    DAYS_OF_WEEK.reduce(
      (prev, curr) => ({
        ...prev,
        [curr]: create24HourSlots(),
      }),
      {},
    ),
  );

  return result;
};
